import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';

import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { ProblemOptionsModel, StudentRequest, StudentAnswerResponse } from '@generativ/much-smarter-models';

import { ProblemInfo } from './ProblemInfo';
import { environment } from '../../../../../environments/environment';
import { ErrorHandlerService } from '../../../../core/services/error-handler.service';
import { ExerciseService } from './exercise.service';
import { ParamsService } from '../../../../shared/params.service';


@Injectable({ providedIn: 'root' })
export class ProblemService {

  strategyProblem: ProblemInfo;

  private lessonUrl = environment.msStudentApiUrl + 'lessons/';
  private answerPracticeUrl = environment.msStudentApiUrl + 'progress/answer';
  private answerStrategyUrl = environment.msStudentApiUrl + 'progress/strategyProblemAnswer';

  index = 0;

  currentProblem: Observable<ProblemInfo>;

  constructor(private http: HttpClient,
              private activatedRoute: ActivatedRoute,
              private errorHandlerService: ErrorHandlerService,
              private exerciseService: ExerciseService,
              private paramsService: ParamsService) {
  }

  /**
   * Save user answer. It will send student answer, and time spent completing this current problem.
   * API will return correct answer.
   *
   * @param problemId
   * @param answer
   * @returns
   */
  saveUserAnswer(exerciseId: number, solutionId: number, answer: string, isPersistence = false): Observable<string> {
    const problemCase = this.paramsService.getRouteDataById('problemCase', this.activatedRoute.snapshot).toString();
    const userAnswer = new StudentRequest.Answer();
    userAnswer.solutionId = solutionId;
    userAnswer.answer = answer;

    const timeSpent = this.getProblemTimeSpent();
    userAnswer.time = timeSpent;
    if (problemCase === 'practiceProblem') {
      userAnswer.persistRound = false;
    }
    return new Observable(observer => {

      this.http.post<StudentAnswerResponse>(this.getEndpointFromProblemCase(problemCase), userAnswer).subscribe(
        studentAnswerResponse => {
          if (isPersistence) {
            this.exerciseService.saveResultPersistenceRound(userAnswer.time, studentAnswerResponse.isCorrect ? 1 : 0);
          }
          observer.next(studentAnswerResponse.correctAnswer);
          observer.complete();
        },
        error => {
          this.errorHandlerService.handleError(error);
        }
      );
    });
  }

  /**
   * Todo: Connect with real API.
   * If is strategyProblem will hit getStrategyProblemByLessonId API endpoint (not ready yet)
   * In other case will hit get Current Problem
   *
   * @param lessonId
   * @param isStrategyProblem
   * @param isPersistence
   * @returns
   */
  getCurrentProblemInfo(lessonId: number, exerciseId: number): Observable<ProblemInfo> {
    const problemCase = this.paramsService.getRouteDataById('problemCase', this.activatedRoute.snapshot).toString();
    if (problemCase === 'strategyProblem') {
      return this.getStrategyProblem(lessonId);
    } else {
      return this.exerciseService.getCurrentProblem();
    }
  }

  private getStrategyProblem(lessonId: number): Observable<ProblemInfo> {
    return new Observable(observer => this.http.get<ProblemOptionsModel>(this.lessonUrl + 'getStrategyProblem/' + lessonId).subscribe(
        problemOptionModel => {
          const problemInfo = new ProblemInfo();
          problemInfo.problem = problemOptionModel;
          observer.next(problemInfo);
          observer.complete();
        },
        error => {
          this.errorHandlerService.handleError(error);
        }
      ));
  }

  /**
   * Start timer.
   *
   * @param problemId
   */
  startProblemTimer(problemId: number) {
    const problemStored = +localStorage.getItem('currentProblemId');
    if (problemId !== problemStored) {
      const now = new Date();
      localStorage.removeItem('currentProblemEnd');
      localStorage.setItem('currentProblemStart', now.toString());
      localStorage.setItem('currentProblemId', problemId.toString());
    }
  }

  /**
   * Pause timer.
   *
   * @param problemId
   */
  pauseProblemTimer() {
    const now = new Date();
    localStorage.setItem('currentProblemEnd', now.toString());
  }

  /**
   * Returns time spent in seconds.
   *
   * @returns
   */
  getProblemTimeSpent(): number {
    const startDateString = localStorage.getItem('currentProblemStart');
    const endDateString = localStorage.getItem('currentProblemEnd');
    const startDate: Date = startDateString ? new Date(startDateString) : new Date();
    const endDate: Date = endDateString ? new Date(endDateString) : new Date();
    return Math.floor((endDate.getTime() - startDate.getTime()) / 1000);
  }

  /**
   * Returns problem's hint.
   * // Todo: Call real api endpoint.
   *
   * @param problemId
   * @returns
   */
  getHint(problemId: number): Observable<string> {
    return of('TBD Hint');
  }

  private getEndpointFromProblemCase(problemCase: string): string {
    if (problemCase === 'practiceProblem') {
      return this.answerPracticeUrl;
    }
    return this.answerStrategyUrl;
  }
}
